import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import { FunctionField } from 'react-admin';
import { connect } from 'react-redux';

const TimezoneAwareDateField = ({ source, storedTimezone, format = 'DD/MM/YYYY, HH:mm:ss', ...rest }) => {
  const effectiveTimezone = storedTimezone || moment.tz.guess();

  return (
    <FunctionField
      source={source}
      render={record => {
        if (!record || !record[source]) return null;

        const dateInTimezone = moment(record[source].toString()).tz(effectiveTimezone);
        return dateInTimezone.format(format);
      }}
      {...rest}
    />
  );
};

TimezoneAwareDateField.propTypes = {
  source: PropTypes.string.isRequired,
  storedTimezone: PropTypes.string,
  timezone: PropTypes.string,
  format: PropTypes.string,
};

const mapStateToProps = state => ({
  storedTimezone: state.configuration.fleet.timezone,
});

export default connect(mapStateToProps)(TimezoneAwareDateField);
